var _rect, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartPlaceholder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 240,
    viewBox: "0 0 320 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    rx: 22,
    fill: "#F4F3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 58,
    width: 176,
    height: 124,
    rx: 14,
    fill: "#FFFFFF",
    stroke: "#D7D9E8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 102,
    r: 15,
    fill: "#E4E7F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 161L129 119L158 146L180 125L233 177H87V161Z",
    fill: "#CBD1E1"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 211,
    textAnchor: "middle",
    fill: "#9CA3B5",
    fontFamily: "Arial, sans-serif",
    fontSize: 13
  }, "Part image unavailable")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartPlaceholder);
export default __webpack_public_path__ + "static/media/part-placeholder.d792bad90ec7a8b6b474a3173008333b.svg";
export { ForwardRef as ReactComponent };